import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import { useEffect, useState } from 'react';
import PollingInputChoice from './PollingInputChoice';
import { IconRemove } from './styled';
import { PollingOptionItem } from '../types';

interface PollingInputChoiceListProps {
  onChangeList: (val: any) => any;
}

function PollingInputChoiceList({ onChangeList }: PollingInputChoiceListProps) {
  const [timeInterval, setTimeInterval] = useState(0);
  const [listChoice, setListChoice] = useState<Array<PollingOptionItem>>([
    { id: 1, value: '' },
    { id: 2, value: '' },
  ]);

  useEffect(() => {
    const data = {
      polling_options: listChoice,
    };
    onChangeList(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listChoice.length]);

  const onChangeInputChoice = (e, key) => {
    const choiceIdx = listChoice.findIndex((c) => c.id === key);
    const newChoice = listChoice.map((c) => ({ ...c }));
    if (choiceIdx > -1) {
      newChoice[choiceIdx].value = e.target.value;
      setListChoice(newChoice);

      if (timeInterval) {
        clearTimeout(timeInterval);
      }

      setTimeInterval(
        window.setTimeout(() => {
          onChangeList({ polling_options: newChoice });
        }, 300),
      );
    }
  };

  const addChoice = () => {
    // Prevent duplicate key if user delete and add new choice
    const newChoiceKey = listChoice[listChoice.length - 1].id + 1;
    setListChoice(
      (prevState) => prevState.concat({ id: newChoiceKey, value: '' }),
      // eslint-disable-next-line function-paren-newline
    );
  };
  const removeChoice = (key) => {
    setListChoice((prevState) => prevState.filter((e) => e.id !== key));
  };

  return (
    <>
      {listChoice.map((e, i) => (
        <PollingInputChoice
          key={e.id}
          onChange={(el) => onChangeInputChoice(el, e.id)}
          placeholder={`Choice ${e.id}`}
          iconRemove={
            (i === listChoice.length - 1 && i > 1)
              ? () => <IconRemove onClick={() => removeChoice(e.id)} />
              : () => {}
          }
        />
      ))}
      {listChoice.length < 10 && (
        <Button type="borderless">
          <Text color={color.primary} onClick={addChoice}>
            + Add a Choice
          </Text>
        </Button>
      )}
    </>
  );
}

export default PollingInputChoiceList;
